/** Given a string and an index somewhere within it, finds the start location of
 * the previous n words. Use for determining where to start a search snippet, given
 * the location of the search term within it. */
const findPrecedingWordbreak = (
  text: string,
  index: number,
  words: number,
  maxChars: number
) => {
  let start = index;
  let breakLocation = index;
  let wordCount = 0;

  while (start > 0 && wordCount < words + 1 && index - start < maxChars) {
    if (text[start] === ' ') {
      wordCount++;
      breakLocation = start;
    }
    start--;
  }

  return start === 0 ? 0 : breakLocation;
};

export const findTextMatch = (text: string, sanitisedTerm: string) => {
  const normalisedText = text.toLowerCase();
  const index = normalisedText.indexOf(sanitisedTerm);
  if (index !== -1) {
    const start = findPrecedingWordbreak(text, index, 2, 15);
    const end = text.indexOf(' ', start + 50);
    const preview = {
      before: text.substring(start, index).trimStart(),
      match: text.substring(index, index + sanitisedTerm.length).trim(),
      after: text
        .substring(index + sanitisedTerm.length, end !== -1 ? end : undefined)
        .trimEnd(),
    };

    return preview;
  }
};
